
export const loadHbridge = () => import(/* webpackChunkName:"npm/@hb/hbridge" */'@hb/hbridge');

export const loadQs = () => import(/* webpackChunkName:"npm/qs" */'qs').then((r) => r.default);
